import React from 'react';
import Dropdown from '@domain-group/fe-co-allhomes-dropdown';
import Selector from '../selector/selector';
import * as styles from './allhomes-search-sorting-tablet.style';
import { defaultSortOption, sortOptions } from './sort-options';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesSearchSortingTablet = _ref => {
  var align = _ref.align,
    _ref$listingType = _ref.listingType,
    listingType = _ref$listingType === void 0 ? 'SALES_RESIDENTIAL' : _ref$listingType,
    _ref$searchType = _ref.searchType,
    searchType = _ref$searchType === void 0 ? 'normal' : _ref$searchType,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultSortOption : _ref$value,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? () => {} : _ref$onSelect;
  var dropdownRef = React.useRef(null);
  var handleSelect = selected => {
    if (dropdownRef.current && dropdownRef.current.ensureClosed) {
      dropdownRef.current.ensureClosed();
    }
    onSelect(selected);
  };
  return ___EmotionJSX(Dropdown, {
    align: align,
    title: "Sort",
    css: styles.container,
    anchorClass: "sorting-tablet-anchor",
    hasIcon: true
  }, ___EmotionJSX(Selector, {
    options: sortOptions({
      listingType,
      searchType
    }),
    selectedValue: value,
    onSelect: handleSelect
  }));
};